import Game from '../modules/Game.class.js';

const game = new Game();

const gameField = document.querySelector('.game-field');
const tilesLayer = document.querySelector('.tiles');
const scoreElement = document.querySelector('.game-score');
const startButton = document.querySelector('.button');
const messageStart = document.querySelector('.message-start');
const messageLose = document.querySelector('.message-lose');
const messageWin = document.querySelector('.message-win');

const CELL = 75;
const GAP = 10;

const tileEls = new Map();

function hideAllMessages() {
  messageStart.classList.add('hidden');
  messageLose.classList.add('hidden');
  messageWin.classList.add('hidden');
}

function pos(row, col) {
  return {
    x: col * (CELL + GAP) + GAP,
    y: row * (CELL + GAP) + GAP,
  };
}

function createTileEl(tile) {
  const el = document.createElement('div');

  el.className = `tile tile--${tile.value}`;
  el.dataset.id = String(tile.id);

  const inner = document.createElement('div');

  inner.className = 'tile__inner';
  inner.textContent = String(tile.value);

  el.appendChild(inner);
  tilesLayer.appendChild(el);

  return el;
}

function setTilePosition(el, row, col) {
  const { x, y } = pos(row, col);

  el.style.transform = `translate(${x}px, ${y}px)`;
}

function updateBoard() {
  const tiles = game.getTiles();
  const nextIds = new Set(tiles.map((t) => t.id));

  for (const [id, el] of tileEls) {
    if (!nextIds.has(id)) {
      el.remove();
      tileEls.delete(id);
    }
  }

  for (const t of tiles) {
    let el = tileEls.get(t.id);

    if (!el) {
      el = createTileEl(t);
      tileEls.set(t.id, el);
      setTilePosition(el, t.row, t.col);

      const inner = el.querySelector('.tile__inner');

      if (t.isNew) {
        inner.classList.add('tile__inner--spawn');

        window.setTimeout(
          () => inner.classList.remove('tile__inner--spawn'),
          180,
        );
      }
    }

    el.className = `tile tile--${t.value}`;

    const inner = el.querySelector('.tile__inner');

    inner.textContent = String(t.value);

    requestAnimationFrame(() => {
      setTilePosition(el, t.row, t.col);
    });

    if (t.isMerged) {
      inner.classList.add('tile__inner--merge');

      window.setTimeout(
        () => inner.classList.remove('tile__inner--merge'),
        220,
      );
    }
  }
}

function updateScore() {
  scoreElement.textContent = String(game.getScore());
}

function updateStatus() {
  const st = game.getStatus();

  if (game.isStarted) {
    startButton.textContent = 'Restart';
    startButton.classList.remove('start');
    startButton.classList.add('restart');
  } else {
    startButton.textContent = 'Start';
    startButton.classList.add('start');
    startButton.classList.remove('restart');
  }

  hideAllMessages();

  if (st === 'win') {
    messageWin.classList.remove('hidden');
  } else if (st === 'lose') {
    messageLose.classList.remove('hidden');
  } else if (st === 'idle') {
    messageStart.classList.remove('hidden');
  }
}

function updateUI() {
  updateBoard();
  updateScore();
  updateStatus();
}

function resetUiTiles() {
  for (const [, el] of tileEls) {
    el.remove();
  }
  tileEls.clear();
}

function handleStartClick() {
  if (game.getStatus() === 'playing' || game.isStarted) {
    game.restart();
    resetUiTiles();
  } else {
    game.start();
  }
  updateUI();
}

function handleKeyDown(e) {
  if (game.getStatus() !== 'playing') {
    return;
  }

  let moved = false;

  switch (e.key) {
    case 'ArrowLeft':
      moved = game.moveLeft();
      break;
    case 'ArrowRight':
      moved = game.moveRight();
      break;
    case 'ArrowUp':
      moved = game.moveUp();
      break;
    case 'ArrowDown':
      moved = game.moveDown();
      break;
    default:
      return;
  }

  if (moved) {
    e.preventDefault();
    updateUI();
  }
}

function init() {
  if (!startButton || !gameField || !scoreElement || !tilesLayer) {
    return;
  }

  startButton.addEventListener('click', handleStartClick);
  document.addEventListener('keydown', handleKeyDown);

  updateUI();
}

init();
